import React from 'react'

import Variant1 from './variants/v1'
import Variant2 from './variants/v2'
import Variant3 from './variants/v3'
import Variant4 from './variants/v4'
import Variant5 from './variants/v5'

// we removed the V1 so I added a null here to keep things working
const variants = [Variant1, Variant2, Variant3, Variant4, Variant5]

export default class OnboardingLayout extends React.PureComponent {
  static propTypes = {
    variant: {
      isRequired(props, propName, componentName) {
        const val = props[propName]
        if (!Number.isInteger(val) || val < 1 || val > 5) {
          return new Error(
            `Invalid prop ${propName} supplied to ${componentName}. Must be a number between 1 and 5.`
          )
        }
        return null
      },
    }.isRequired,
  }

  render() {
    const { variant, ...rest } = this.props
    // NOTE (jscheel): Prop is 1-indexed
    const VariantComponent = variants[this.props.variant - 1]
    return <VariantComponent {...rest} />
  }
}
